import { MissingAppointmentsDto } from "@apiModels/MissingAppointments/MissingAppointmentsDto.csharp";

export const missingAppointmentsInitialState: MissingAppointmentsDto = {
  centerIds: [],
  doctorIds: [],
  doctorsAndCenters: [],
  centerMessage: "",
  centerWithoutOnlineBookingMessage: "",
  doctorMessage: "",
  doctorAndCenterMessage: "",
  serviceWithoutOnlineBookingMessage: "",
  locationWithoutOnlineBookingMessage: ""
};
